// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'wand';

export const Component = () => (
  <path d='M.67 24.329 0 23.61l8.669-8.669.718.67-8.716 8.717Zm12.021-1.34v-6.131h1.006v6.13H12.69Zm7.71-3.21-4.166-4.166.719-.67 4.119 4.118-.67.719-.001-.001Zm-2.25-7.998v-1.005h6.13v1.005h-6.13Zm-1.198-3.736-.719-.67 4.167-4.166.67.718-4.119 4.12.001-.002Zm-4.262-1.963V0h1.006v6.082H12.69ZM8.668 8.045 4.549 3.927l.67-.72 4.167 4.167-.719.67.001.001Zm-7.375 3.736v-1.005h6.082v1.005H1.293Z' />
);

export const viewBox = '0 0 25 25';
